import React, { useEffect, useState } from 'react';
import FilterIcon from '../../SVG/Filter';

const FAQSection = () => {
    const [faqs, setFaqs] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [expandedFaq, setExpandedFaq] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const apiURL = import.meta.env.VITE_API;

    useEffect(() => {
        const loadFAQs = async () => {
            setLoading(true);
            setError(null);

            try {
                const res = await fetch(
                    `${apiURL}/Provider/getFAQ`,
                    {
                        method: 'GET'
                    }
                );
                if (!res.ok) {
                    throw new Error('Unable to load FAQs.');
                }

                const data = await res.json();

                // Normalize to a single object (in case API returns array)
                const faqList = Array.isArray(data) ? data : [];

                if (faqList.length === 0) {
                    setFaqs([]);
                    setError('No related FAQ information found.');
                    return;
                }

                setFaqs(data);

            } catch (err) {
                console.error('Error fetching FAQ items:', err);
                setError('Failed to load FAQ items. Please try again.');
                setFaqs([]);
            } finally {
                setLoading(false);
            }
        };

        loadFAQs();

    }, []);

    const handleFAQClick = (id) => {
        setExpandedFaq(
            prevId => prevId === id ? null : id
        );
    };

    const filteredFAQs = [...faqs]
        .filter(faq => faq.active !== false)
        .filter(faq =>
            (faq.question || '').toLowerCase().includes(searchText.toLowerCase()) ||
            (faq.answer || '').toLowerCase().includes(searchText.toLowerCase())
        ).sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));

    return (
        <div className="container container-section">
            <div className="filter-box">
                <FilterIcon />
                <div className="filter-item">
                    <label htmlFor="faqSearch" className="filterLabel">
                        Search FAQs:
                    </label>
                    <input
                        type="text"
                        id="faqSearch"
                        className="filterInput"
                        value={searchText}
                        onChange={e => setSearchText(e.target.value)}
                    />
                </div>
            </div>

            {/* Error */}
            {error && <div className="faq__error">{error}</div>}

            {/* Loading */}
            {loading && (
                <div className="faq__card">
                    <h4>Loading FAQ items...</h4>
                </div>
            )}

            {/* Result */}
            {!loading && !error && filteredFAQs.length > 0 &&(
                <div className="faq__card">
                    <h3 className="faq__title">Frequently Asked Questions</h3>

                    <div className="faq__list">
                        {filteredFAQs.map(faq => { 
                            const isExpanded = expandedFaq === faq.faqid;

                            return(
                                <div
                                    key={faq.faqid}
                                    className={`faq__item ${isExpanded ? 'faq__item--open' : ''}`}
                                >
                                    <button
                                        type="button"
                                        className="faq__question"
                                        onClick={() => handleFAQClick(faq.faqid)}
                                        aria-expanded={isExpanded}
                                        aria-controls={`faq-answer-${faq.faqid}` }
                                    >
                                        <span className="faq__question-text">{faq.question}</span>

                                        <span className={`faq__icon ${isExpanded ? 'faq__icon--open' : ''}`}
                                              aria-hidden="true"         
                                        >
                                           + {/*{expandedFaq === faq.faqid ? '-' : '+'}*/}
                                        </span>
                                    </button>

                                    {isExpanded && (
                                        <div id={`faq-answer-${faq.faqid}`}
                                            className="faq__answer">
                                            {faq.answer}
                                        </div>
                                    )}
                                </div>
                             );
                        })}
                    </div>
                </div>
            )}

            {/* No Results */}
            {!loading && !error && filteredFAQs.length === 0 && (
                <div className="faq__card">
                    <h4>No FAQ items found.</h4>
                </div>
            )}
        </div>
    );
};

export default FAQSection;